
import Lifebuoy from "../../../assets/outline/Lifebuoy.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LifebuoyIcon({ className, dataTestid = "LifebuoyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Lifebuoy data-testid={dataTestid} className={classes} {...rest} />
  );
}
